<div class="viewer">

    <ng-container *ngIf="isLoaded; else loading">
        <iframe *ngIf="hasPermission; else noPermission" [src]="tcmUrl">
        </iframe>
    </ng-container>
</div>

<ng-template #loading>
    <busy-indicator></busy-indicator>
</ng-template>

<ng-template #noPermission>
    <mat-toolbar>
        <span>You do not have permission for TCM. Please contact an administrator.</span>
    </mat-toolbar>
</ng-template>